/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type Accountabilities_organization$ref = any;
type RoleTemplateSelector_organization$ref = any;
type WYSIWYGTextareaWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Editor_organization$ref: FragmentReference;
declare export opaque type Editor_organization$fragmentType: Editor_organization$ref;
export type Editor_organization = {|
  +databaseId: string,
  +domainsLabel: string,
  +purposeLabel: string,
  +showAccountabilities: boolean,
  +showDomains: boolean,
  +showPurpose: boolean,
  +roleTemplates: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string
      |}
    |}>
  |},
  +$fragmentRefs: RoleTemplateSelector_organization$ref & Accountabilities_organization$ref & WYSIWYGTextareaWithFeatureFlag_organization$ref,
  +$refType: Editor_organization$ref,
|};
export type Editor_organization$data = Editor_organization;
export type Editor_organization$key = {
  +$data?: Editor_organization$data,
  +$fragmentRefs: Editor_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "domains"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "purpose"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Editor_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": "domainsLabel",
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "termFor",
      "storageKey": "termFor(name:\"domains\")"
    },
    {
      "alias": "purposeLabel",
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "termFor",
      "storageKey": "termFor(name:\"purpose\")"
    },
    {
      "alias": "showAccountabilities",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "accountabilities"
        }
      ],
      "kind": "ScalarField",
      "name": "featureEnabled",
      "storageKey": "featureEnabled(name:\"accountabilities\")"
    },
    {
      "alias": "showDomains",
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "featureEnabled",
      "storageKey": "featureEnabled(name:\"domains\")"
    },
    {
      "alias": "showPurpose",
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "featureEnabled",
      "storageKey": "featureEnabled(name:\"purpose\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "RoleTemplateConnection",
      "kind": "LinkedField",
      "name": "roleTemplates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleTemplateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTemplate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roleTemplates(first:100)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleTemplateSelector_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Accountabilities_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGTextareaWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b6f406afe7710cd11f98302078d71b64';

module.exports = node;
